import { useContext } from 'react';
import {AxiosContext} from "../context/AxiosContext";

export function useAxios() {
  return useContext(AxiosContext);
}
